<script setup lang="ts">
import FeedsAvatar from "~/components/layout/Search/Feeds/FeedsAvatar.vue";
import FeedsFollowButton from "~/components/layout/Search/Feeds/FeedsFollowButton.vue";
import { IFollowingsResult } from "~/components/layout/Search/SearchResults.vue";
import useFeeds from "~/composables/Feeds/useFeeds";

interface Props {
	following: IFollowingsResult | null;
	type: "TEAM" | "COMPETITION";
	homePage?: boolean;
}

const props = defineProps<Props>();

const { followedItems, handleSubscription } = useFeeds();

const active = ref(false);

const filteredSubResult = computed(() => {
	if (props.type === "TEAM") return;
	return props.following?.related?.filter((f) => f.type === "TEAM");
});
</script>

<template>
	<UiAccordion
		@tab-open="active = true"
		@tab-close="active = false"
		:activeIndex="active ? 0 : 1"
		:class="['rounded-md mb-2 text-xs p-3', homePage ? 'bg-light-50 dark:bg-dark-700' : 'bg-light-50 dark:bg-dark-800']"
	>
		<UiAccordionTab :headerWrapperClass="'flex justify-between'">
			<template #header>
				<div class="flex items-center">
					<FeedsAvatar :following="following"></FeedsAvatar>
					<div class="font-bold ml-2 shrink">
						{{ following?.name }}
					</div>
				</div>
			</template>
			<template #header-icon>
				<FeedsFollowButton
					v-if="following?.id"
					@follow="handleSubscription(following?.id, 'FEED_FOLLOW')"
					@unfollow="handleSubscription(following?.id, 'FEED_UNFOLLOW')"
					:active="active"
					@toggle="active = !active"
					:has-children="filteredSubResult && filteredSubResult?.length > 0"
					:is-followed="followedItems.includes(following?.id)"
				></FeedsFollowButton>
			</template>
			<template #default>
				<div
					v-for="team in filteredSubResult"
					:key="team.id"
					class="flex justify-between py-3 last:pb-0 first:border-t first:mt-2 border-light-300 dark:border-dark-600"
				>
					<div class="flex items-center flex-wrap">
						<FeedsAvatar :following="team"></FeedsAvatar>
						<div class="font-bold ml-2">
							{{ team?.name }}
						</div>
					</div>
					<FeedsFollowButton
						:is-followed="followedItems.includes(team?.id)"
						@follow="handleSubscription(team?.id, 'FEED_FOLLOW')"
						@unfollow="handleSubscription(team?.id, 'FEED_UNFOLLOW')"
					></FeedsFollowButton>
				</div>
			</template>
		</UiAccordionTab>
	</UiAccordion>
</template>
<style scoped lang="scss"></style>
